import { render, staticRenderFns } from "./shcl.vue?vue&type=template&id=2206bb0b&scoped=true&"
import script from "./shcl.vue?vue&type=script&lang=js&"
export * from "./shcl.vue?vue&type=script&lang=js&"
import style0 from "./shcl.vue?vue&type=style&index=0&id=2206bb0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206bb0b",
  null
  
)

export default component.exports